import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelJob } from '../api';

export function useCancelJob(jobId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reason?: string) => cancelJob(jobId, reason),
    onSuccess: () => {
      // Invalidate jobs list and specific job
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
    },
  });
}
